module.exports = __webpack_public_path__ + "static/skin-in-the-game-3b51024e183ebf90e64d6ceb08599993.jpg";